import { observable, action } from "mobx";
import CustomerPayment from "~/models/CustomerPayment";
import CustomerPaymentRepository from "~/repository/CustomerPaymentRepository";

class CustomerPaymentStore {
  @observable isLoading = false;

  @observable isSubmitting = false;

  @observable customerPayments = [];

  customerPaymentRepository = null;

  constructor() {
    this.customerPaymentRepository = new CustomerPaymentRepository();
  }

  @action
  load(query) {
    this.isLoading = true;

    return this.customerPaymentRepository.fetch(query).then(response => {
      const { customerPayments } = response.data;

      this.customerPayments.clear();
      customerPayments.forEach(customerPayment => this.customerPayments.push(new CustomerPayment(customerPayment)));
      this.isLoading = false;
    });
  }

  @action
  pay(customerPaymentId, data) {
    this.isSubmitting = true;

    return this.customerPaymentRepository.pay(customerPaymentId, data).finally(() => {
      this.isSubmitting = false;
    });
  }
}

export default CustomerPaymentStore;
